import { createConfirmation } from "react-confirm";
import AddNewLocationDialog from "./AddNewLocationDialog";

export const showAddNewLocationDialog = createConfirmation(AddNewLocationDialog);
